<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.219 16.4158L20.2532 21.451C20.5625 21.7603 21.0649 21.7603 21.3742 21.451C21.6834 21.1417 21.6834 20.6393 21.3742 20.3301L16.356 15.3119C17.5169 13.9358 18.2175 12.1583 18.2175 10.2177C18.2175 5.85302 14.6746 2.31006 10.3099 2.31006C5.94631 2.31006 2.40234 5.85302 2.40234 10.2177C2.40234 14.5823 5.94631 18.1252 10.3099 18.1252C12.1645 18.1252 13.8699 17.4857 15.219 16.4158ZM14.7146 14.7524C15.8976 13.6025 16.6332 11.9951 16.6332 10.2177C16.6332 6.72774 13.7999 3.89538 10.3099 3.89538C6.82104 3.89538 3.98765 6.72774 3.98765 10.2177C3.98765 13.7076 6.82104 16.5409 10.3099 16.5409C12.0114 16.5409 13.5576 15.8674 14.6946 14.7724V14.7714C14.7016 14.7644 14.7086 14.7584 14.7146 14.7524Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Search'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
